function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 -0.000854492C3.58214 -0.000854492 0 3.58129 0 7.99915C0 12.417 3.58214 15.9991 8 15.9991C12.4179 15.9991 16 12.417 16 7.99915C16 3.58129 12.4179 -0.000854492 8 -0.000854492ZM8.57143 11.8563C8.57143 11.9349 8.50714 11.9991 8.42857 11.9991H7.57143C7.49286 11.9991 7.42857 11.9349 7.42857 11.8563V6.99915C7.42857 6.92057 7.49286 6.85629 7.57143 6.85629H8.42857C8.50714 6.85629 8.57143 6.92057 8.57143 6.99915V11.8563ZM8 5.71343C7.7757 5.70885 7.56213 5.61653 7.40512 5.45629C7.24812 5.29604 7.16018 5.08063 7.16018 4.85629C7.16018 4.63194 7.24812 4.41654 7.40512 4.25629C7.56213 4.09604 7.7757 4.00372 8 3.99915C8.2243 4.00372 8.43787 4.09604 8.59488 4.25629C8.75188 4.41654 8.83982 4.63194 8.83982 4.85629C8.83982 5.08063 8.75188 5.29604 8.59488 5.45629C8.43787 5.61653 8.2243 5.70885 8 5.71343Z",
  fill: "#0D53FC"
});

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.a20d8318.svg";
export { ForwardRef as ReactComponent };